export const PLATFORM = {
    WINDOWS: "WINDOWS",
    MAC: "MAC"
}

export const LOADING_STATE = {
    SAVE: "SAVE",
    REMOVE: "REMOVE"
}